/// <amd-module name="Wit/BacklogsHub/Common/Services/IBacklogsDirectoryService" />
import { Services } from "VSS/Platform/Context";
import { DirectoryService, IDirectoryService } from "Wit/DirectoryService/IDirectoryService";
import { DataProviders } from "../BacklogHubContants";

export interface IBacklogsDirectoryService extends IDirectoryService {}

export class BacklogsDirectoryService extends DirectoryService implements IBacklogsDirectoryService {
    protected myDirectoryDataProviderContribution = DataProviders.DirectoryDataProvider;
    protected allDirectoryDataProviderContribution = DataProviders.AllDirectoryDataProvider;
}

Services.add("IBacklogsDirectoryService", { serviceFactory: BacklogsDirectoryService });
